import React from "react";
import { Profiler } from "react";

interface ModelSearchProps {
  modelsJson: string;
  modelsGrouped: ModelGroup[];
  delebiler: boolean;
  firmanavn: string;
  seoContent: string;
  urlPrefix: string;
  predefinedBrand: boolean;
  heading: string;
  route: string;
}

interface ModelGroup {
  Models: Model[];
  ModelGroupName: string;
}

interface Model {
  Model: string;
  Slug: string;
  Brand?: Brand;
  BrandSlug: string;
}

interface Brand {
  Brand: string;
}

export default function BrandSearch({
  modelsGrouped,
  delebiler,
  firmanavn,
  seoContent,
  urlPrefix,
  predefinedBrand,
  heading,
  route,
}: ModelSearchProps) {
  const [searchTerm, setSearchTerm] = React.useState("");

  const getHref = (model: Model) => {
    if (!delebiler) {
      if (predefinedBrand) {
        return `${urlPrefix}/${model.Slug}`;
      }
      return `${urlPrefix}/${model.BrandSlug}/${model.Slug}`;
    }

    return `/${firmanavn}/Delebiler/Søk?partgroup=Biler for demontering&brand=${model.Brand}&Models=${model.Model}&start=1`;
  };

  const getModels = (modelGroups: ModelGroup[]) => {
    if (modelGroups.length <= 1) {
      return (
        <ul className="">
          {modelGroups[0].Models.map((model, index) => {
            if (model.Model.toLowerCase().includes(searchTerm.toLowerCase()))
              return (
                <li className="modelListItem" key={index}>
                  <a
                    className={
                      searchTerm?.length > 1 ? "modelListItemFiltered" : ""
                    }
                    href={getHref(model)}
                  >
                    {model.Model}
                  </a>
                </li>
              );
          })}
        </ul>
      );
    } else {
      return (
        <>
          {modelGroups.map((modelGroup, groupIndex) => {
            return (
              <section key={groupIndex} className="modelGroupSection">
                <h4>{modelGroup.ModelGroupName}</h4>
                <ul className="">
                  {modelGroup.Models.map((model, index) => {
                    if (
                      model.Model.toLowerCase().includes(
                        searchTerm.toLowerCase(),
                      )
                    ) {
                      return (
                        <li className="modelListItem" key={index}>
                          <a
                            className={
                              searchTerm?.length > 1
                                ? "modelListItemFiltered"
                                : ""
                            }
                            href={getHref(model)}
                          >
                            {model.Model}
                          </a>
                        </li>
                      );
                    }
                  })}
                </ul>
              </section>
            );
          })}

          {route === "Bildeler" && (
            <li className="modelListItem">
              <a
                href={getHref({
                  Slug: "alle",
                  Brand: modelGroups[0].Models[0].Brand,
                  Model: "",
                  BrandSlug: modelGroups[0].Models[0].BrandSlug,
                })}
              >
                Velg alle modeller
              </a>
            </li>
          )}
        </>
      );
    }
  };

  return (
    <div className="accordionContent">
      <div className="columnLeft">
        <div className="searchInputContainer">
          <input
            placeholder="Søk modell"
            className="searchBrandByLetterInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <img src="/images/search.png" alt="Search" className="searchImage" />
        </div>
        <h1>{heading}</h1>
        {seoContent?.Value && (
          <div
            className="seoContent"
            dangerouslySetInnerHTML={{ __html: seoContent?.Value }}
          ></div>
        )}
      </div>
      <div className="modelList">
        {route === "Dekk" && (
          <div className="dekkKalkulatorBanner">
            Trenger du hjelp til å finne dekk som kan passe din bil{" "}
            <a
              href={`/${firmanavn}/DekkKalkulator`}
              className="dekkKalkulatorBannerLink"
            >
              <br />
              Prøv vår nye dekkalkulator →
            </a>
          </div>
        )}
        {getModels(modelsGrouped)}
      </div>
    </div>
  );
}
